import { Grid } from '@material-ui/core';
import React from 'react';
import { styles } from './bottle-deposit-header-styles';
import { useTranslation } from 'react-i18next';

const BottleDepositHeader: React.FC = (): JSX.Element => {
  const classes = styles();
  const { t } = useTranslation();
  return (
    <Grid item>
      <Grid
        direction='column'
        spacing={0}
        wrap='nowrap'
        container
        className={`${classes.bottleDepositHeaderContainer}`}
      >
        <Grid item className='fullHeight'>
          <Grid container justifyContent='flex-start' className={classes.row}>
            <Grid item xs={4} className={classes.bottleDepositRowContainer}>
              <Grid container item xs={9} className=''>
                <Grid
                  item
                  className={classes.bottleDepositHeaderText}
                  data-testid={'bd-header-name'}
                >
                  {t('BottleName')}
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={3} className={classes.bottleDepositRowContainer}>
              <Grid justifyContent={'center'} container item xs={9}>
                <Grid
                  item
                  className={classes.bottleDepositHeaderText}
                  data-testid={'bd-header-price'}
                >
                  {t('BottlePrice')}
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={2} className={classes.bottleDepositRowContainer}>
              <Grid container item xs={9} justifyContent={'center'}>
                <Grid
                  item
                  className={`${classes.bottleDepositHeaderText}`}
                  data-testid={'bd-header-return-qty'}
                >
                  {t('ReturnQty')}
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={3} className={classes.bottleDepositRowContainer}>
              <Grid container item xs={9} justifyContent={'center'} className={classes.floatRight}>
                <Grid
                  item
                  className={classes.bottleDepositHeaderText}
                  data-testid={'bd-header-return-amount'}
                >
                  {t('ReturnAmount')}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default BottleDepositHeader;
